import { Tag } from 'client/types/tag';
import * as types from './types';

export interface TagState {
    readonly data: Tag | null;
    readonly isLoading: boolean;
    readonly error?: string | Error;
}

const initialState: TagState = {
    data: null,
    isLoading: false
};

export default function tagReducer(
    state = initialState,
    action: types.TagActionTypes
): TagState {
    switch (action.type) {
    case types.FETCH_TAG_REQUEST:
        return fetchTag(state);
    case types.FETCH_TAG_SUCCESS:
        return fetchTagSuccess(state, action);
    case types.FETCH_TAG_ERROR:
        return fetchTagError(state, action);
    default:
        return state;
    }
}

function fetchTag(state: TagState) {
    return {
        ...state,
        isLoading: true,
        error: undefined
    };
}

function fetchTagSuccess(state: TagState, action: types.FetchTagSuccess) {
    return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: undefined
    };
}

function fetchTagError(state: TagState, action: types.FetchTagError) {
    return {
        ...state,
        data: initialState.data,
        isLoading: false,
        error: action.payload
    };
}
